module.exports = __webpack_public_path__ + "img/qysj_bg3.f2bd345c.png";